import { Component, input } from '@angular/core';

import { Promotion } from '../../types/promotion';
import { UiCoreModule } from '@softline/ui-core';
import { PriceCardComponent } from '../price-card/price-card.component';

@Component({
    selector: 'soft-promotion-card',
    imports: [UiCoreModule, PriceCardComponent],
    templateUrl: './promotion-card.component.html',
    styleUrl: './promotion-card.component.css'
})
export class PromotionCardComponent {
  promotion = input.required<Promotion>();
}
